import { ModuleWithProviders, NgModule } from '@angular/core';
import { AppcuesService, APPCUES_CONFIG } from './appcues.service';
import { EnvironmentConfig } from './interfaces/environment.interface';

export * from './appcues-constants';
export * from './interfaces/appcues-types';
export * from './interfaces/appcues.service.interface';
export * from './appcues.service';

@NgModule({
  declarations: [],
  providers: [AppcuesService],
})
export class AppcuesModule {
  static forRoot(
    config: EnvironmentConfig
  ): ModuleWithProviders<AppcuesModule> {
    return {
      ngModule: AppcuesModule,
      providers: [
        {
          provide: APPCUES_CONFIG,
          useValue: config || {},
        },
        AppcuesService,
      ],
    };
  }
}
